import TariffService from "./TariffService"
export default TariffService
